import "./accountCancelViewWizardMotiveSelect.scss"

import React from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { i18n } from 'core/i18n';
const { formatText } = i18n;

import OKSelect from 'components/commons/OKSelect/OKSelect';
import InputCharsLeft from "components/inputCharsLeft/inputCharsLeft";

import { getMotiveSelectOptions } from "../../helpers/accountCancelViewHelper";

function AccountCancelViewWizardMotiveSelect(props) {
    const { immAccountCancel, onSelectChange, onInputChange } = props;
    const { motiveSelect, motiveDetail } = immAccountCancel.toJS();

    const handleSelectChange = (option) => {
        onSelectChange(option.value);
    };

    const handleInputChange = (value) => {
        onInputChange(value);
    }

    return (
        <section className="account-cancel-motive-select">
            <OKSelect
                label={formatText("cancellation_account-account_cancellation_request_step1_dropdown_title")}
                onChange={handleSelectChange}
                options={getMotiveSelectOptions()}
                value={motiveSelect}
                autosize={false}
                placeholder={formatText("hireContactDataForm-hireContactDataForm_combosPlaceholder")}
                errorState={false}
                searchable={false}
            />
            {
                motiveSelect === "other" && (
                    <div className="account-cancel-motive-select__detailsInput">
                        <InputCharsLeft
                            label={formatText("cancellation_account-cancellation_account_dropdown_6_text_input")}
                            initialValue={motiveDetail}
                            callback={handleInputChange}
                            maxLength={500}
                        />
                    </div>
                )
            }

        </section>
    )
}

AccountCancelViewWizardMotiveSelect.propTypes = {
    immAccountCancel: PropTypes.instanceOf(Immutable.Map).isRequired,
    onSelectChange: PropTypes.func.isRequired,
    onInputChange: PropTypes.func.isRequired,
};



export default AccountCancelViewWizardMotiveSelect;